<mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      <mat-icon>menu</mat-icon> My Drive 
    </button>
  </div>
  <div class="d">  
  </div>
</mat-card>

<div class="coreholder" fxLayout="row">
  <!-- My Drive -->
  <mat-card class="myDrive" [ngClass]="{ open: showmyDrive }">
    <app-left-menu></app-left-menu>
  </mat-card>

  <div
    class="myDriveOverlay"
    (click)="showMyDrive()"
    [ngClass]="{ open: showmyDrive }">
  </div>

  <!-- My Drive -->

  <!-- Core page Structure -->
  <div class="corepages">
    <!-- Filter -->
    <mat-card class="filter">
      <label>Projects</label>
      <div class="slAct">      
        <button (click)="deleteSentProjects()" *ngIf="SelectedRecordForDeleFav" mat-icon-button><mat-icon>delete_outline</mat-icon></button>
      </div>

      <!-- <mat-form-field appearance="" class="statusType">
        <mat-label>Sent Type</mat-label>
        <mat-select [(ngModel)]="StatusType" (selectionChange)="filterSentType($event.value)">
           <mat-option value="All">All</mat-option>
           <mat-option value="Completed" >Completed</mat-option>
           <mat-option value="Progress">In Progress</mat-option>
           <mat-option value="Sent" >Mail Sent</mat-option>          
        </mat-select>
      </mat-form-field>  -->


      <div class="projectSearch">
      
        <button class="searchbtn" [disabled]="pageModelData.searchValue==''"  mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>
       
        <input placeholder="Search projects" type="text"  maxlength="200" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
       
        <button class="filterbtn" mat-icon-button (click)="applyAdvFilter(advFilter)"
        matTooltipClass="tooltip" matTooltip="Filters">
       <mat-icon>filter_list</mat-icon>
      </button>
     

     </div>

      <!-- <button class="filterbtn" mat-icon-button>
        <mat-icon>filter_list</mat-icon>
      </button> -->

      <!-- <div class="add">
        <button mat-flat-button color="primary" (click)="CreatePdfForm()">Create PDF Form</button>
      </div> -->

      <div class="add">
        <button mat-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>add</mat-icon> Create</button>
        <mat-menu #menu="matMenu">
        <button mat-menu-item  (click)="CreatePdfForm(true)">PDF Form</button>
        <button mat-menu-item  (click)="CreateAuditForm(true)">Tabular Form</button>
        <button mat-menu-item  (click)="CreateHTMLForm(true)">HTML Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreatePdfForm(false)">Master PDF Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateAuditForm(false)">Master Tabular Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateHTMLForm(false)">Master Web Form</button>
      </mat-menu>       
      </div>
      
    </mat-card>
    <!-- Filter -->

    <!-- <mat-card class="emailList" *ngIf="showAdvSearchList==false">
     
      <mat-table  [dataSource]="dataSource" matSort matSortDisableClear matSortDirection="asc">
        <ng-container matColumnDef="projectId">
          <div *matHeaderCellDef class="check">
             <mat-checkbox color="primary" [disabled]="noRecordFound"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
          </div>
          <div *matCellDef="let sent" class="check">
            <mat-checkbox color="primary" (change)="isAllSelectedRow($event,sent)"
            (change)="$event ? selection.toggle(sent) : null"
            [checked]="selection.isSelected(sent)"></mat-checkbox>
          </div>
        </ng-container>
      
        <ng-container matColumnDef="subject">
          <div *matHeaderCellDef mat-sort-header class="subject">
            Subject
          </div>

          <div *matCellDef="let sent" class="subject">
            <h4>{{ sent.subject }}</h4>
          </div> 
        </ng-container>

        <ng-container matColumnDef="projectName">
          <div *matHeaderCellDef mat-sort-header class="subject">
            Project Name
          </div>

          <div *matCellDef="let sent" class="subject">
            <h4><a matTooltip="Show Signing Page" matTooltipShowDelay="1500" matTooltipClass="tooltip" 
              class="btn-primary btnGlobal"
              href="{{sent.signingToken}}" target="_blank">{{ sent.name }}</a></h4>
          </div> 
        </ng-container>

        
        <ng-container matColumnDef="status">
          <div *matHeaderCellDef mat-sort-header class="update">
            Status
          </div>

          <div *matCellDef="let sent" class="update">           
            <p *ngIf="sent.status==0">Drafted</p>
            <p *ngIf="sent.status==1">Mail Sent</p>
            <p *ngIf="sent.status==2">In-progress</p>
            <p *ngIf="sent.status==3">Completed</p>
            <p *ngIf="sent.status==4">Withdraw</p>
            <p *ngIf="sent.status==5">Declined</p>
          </div> 
        </ng-container> 
          

        <ng-container matColumnDef="sentOn">
          <div *matHeaderCellDef mat-sort-header class="update">Sent On</div>        
          <p  *matCellDef="let sent" class="update sepDateTime"> 
            <span>{{ sent.createdOn+'Z' | date: "MM/dd/yyyy"}}</span>         
            <span class="time">{{ sent.createdOn+'Z' | date: "h:mm a" }}</span>        
          </p>
        </ng-container>         
      
        <ng-container matColumnDef="action">
          <div class="action" *matHeaderCellDef>Action</div>

        <div class="action" *matCellDef="let sent" (click)="$event.stopPropagation()">            
          
          <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
            <mat-icon>more_vertical</mat-icon> 
          </button>
          <mat-menu #formTypeOpt="matMenu" xPosition="before">     
            
            <a href="{{sent.signingToken}}" target="_blank" mat-menu-item  matTooltipClass="tooltip" matTooltip="View Project">
              <mat-icon>preview</mat-icon> View Project
            </a>

            <button mat-menu-item (click)="resetProject(sent)" matTooltipClass="tooltip" matTooltip="Edit & Reset Project">
              <mat-icon>create</mat-icon> Edit & Reset
            </button>

            <button mat-menu-item [disabled]="sent.status!=3" (click)="downloadDocument(sent)" matTooltipClass="tooltip" matTooltip="Download">
              <mat-icon>cloud_download</mat-icon> Download
            </button>

            <button mat-menu-item  (click)="movetoTrash(sent.projectInboxSentId)" matTooltipClass="tooltip" matTooltip="Move to trash">
             <mat-icon>delete_outline</mat-icon> Delete
            </button>

          </mat-menu>

        </div>
        </ng-container>
        <mat-header-row  class="list ehead" *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row (click)="showParticipantDetail(row)" class="list erow"
        [ngClass]="{'selected_row': row.projectInboxSentId === projectInboxSentId }"  *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <div *ngIf="noRecordFound" class="noRecordFound">No Record Found</div>

      <mat-paginator *ngIf="!noRecordFound" [length]="paginatorTotalLength"
      [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]"
      itemsPerPageLabel="Records Per Page" showFirstLastButtons
      (page)="pageEventPropogate($event)">
      </mat-paginator>
    </mat-card>     -->


    <mat-card class="emailList">
     
      <mat-table  [dataSource]="dataSource" matSort matSortDisableClear matSortDirection="asc">
        <ng-container matColumnDef="projectId">
          <div *matHeaderCellDef class="check">
             <mat-checkbox color="primary" [disabled]="noRecordFound"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
          </div>
          <div *matCellDef="let sent" class="check">
            <mat-checkbox color="primary" (change)="isAllSelectedRow($event,sent)"
            (change)="$event ? selection.toggle(sent) : null"
            [checked]="selection.isSelected(sent)"></mat-checkbox>
          </div>
        </ng-container>
      
        <ng-container matColumnDef="status">
          <div *matHeaderCellDef mat-sort-header style="width: 40px;">
            <!-- Status -->
          </div>
          <div *matCellDef="let sent" style="width: 40px;">  
          <button style="color:#11c211;" *ngIf="sent.status==3" mat-icon-button matTooltip="Completed">
          <mat-icon>check_circle_outline</mat-icon>
          </button>
          <button *ngIf="sent.status==2" mat-icon-button matTooltip="In-progress">
            <mat-icon>check_circle_outline</mat-icon>
           </button>
           <button *ngIf="sent.status==1" mat-icon-button matTooltip="Mail Sent">
            <mat-icon>send</mat-icon>
           </button>
          </div>
          <!-- <div *matCellDef="let sent" class="update">           
            <p *ngIf="sent.status==0">Drafted</p>
            <p *ngIf="sent.status==1">Mail Sent</p>
            <p *ngIf="sent.status==2">In-progress</p>
            <p *ngIf="sent.status==3">Completed</p>
            <p *ngIf="sent.status==4">Withdraw</p>
            <p *ngIf="sent.status==5">Declined</p>
          </div>  -->
        </ng-container> 

        <ng-container matColumnDef="name">
          <div *matHeaderCellDef mat-sort-header class="subject">
            Project
          </div>

          <div *matCellDef="let sent" class="subject">
            <h4>{{ sent.name }}</h4>
            <span class="emailSubject" >{{ sent.subject }}</span>
          </div> 
        </ng-container>
      
          <ng-container matColumnDef="Active">
          <div *matHeaderCellDef mat-sort-header class="authorName">
            Active
          </div>

          <div *matCellDef="let sent" class="authorName">            
           <span style="color: #03a9f4;" class="emailSubject"  matTooltipClass="tooltip" matTooltip="Active Group">{{ sent.activeGroup }}</span>          
          </div>
        
        </ng-container>

        <ng-container matColumnDef="authorName">
          <div *matHeaderCellDef mat-sort-header class="authorName">
            Author
          </div>

          <div *matCellDef="let sent" class="authorName">
            
            <div class="userpicinfo">

              <ul class="assignList">
                              
                <span class="shortName" matTooltipClass="tooltip" matTooltip="{{sent.authorFullName}}">
                  {{ getShortName(sent.authorFullName) }}
                </span> 
              </ul>

            </div>
           

          </div>

          <!-- <div *matCellDef="let sent" class="subject">
            <span class="shortName" matTooltipClass="tooltip" matTooltip="{{sent.authorFullName}}">
              {{ getShortName(sent.authorFullName) }}
            </span>            
          </div>  -->
        </ng-container>

        <ng-container matColumnDef="Assignee">
          <div *matHeaderCellDef mat-sort-header class="update">
            Assignee
          </div>

          <div *matCellDef="let sent" class="update">
            
            <div class="userpicinfo">

              <ul class="assignList">
                <ng-container *ngFor="let item of sent.participants; let i = index;">

                  <li *ngIf="i <= 3">
                    <!-- <ng-container *ngIf="item.image; else showName">
                      <div class="userImage" matTooltipClass="tooltip"   matTooltip="{{item.name}}">
                        <img src="{{item.image}}" alt="{{item.name}}">
                      </div>
                    </ng-container> -->

                   
                        <span class="shortName" matTooltipClass="tooltip" matTooltip="{{item.participantName}}">
                          {{ getShortName(item.participantName) }}
                        </span> 
              
                  </li>
                  <li *ngIf="i > 3 && i == 4">
                    <span class="shortName">
                      +{{4}}
                    </span> 
                  </li>


                </ng-container>

                <ng-container *ngIf="sent.participants.length == 0;">
                  <li> -  </li>
                </ng-container>

              </ul>

            </div>
           

          </div> 
        </ng-container>                     

        <ng-container matColumnDef="sentOn">
          <div *matHeaderCellDef mat-sort-header class="update">Sent On</div>        
          <p  *matCellDef="let sent" class="update sepDateTime"> 
            <span>{{ sent.createdOn+'Z' | date: "MM/dd/yyyy"}}</span>         
            <span class="time">{{ sent.createdOn+'Z' | date: "h:mm a" }}</span>        
          </p>
        </ng-container>         
      
        <ng-container matColumnDef="attachType">
          <div *matHeaderCellDef mat-sort-header style="width: 60px; text-align: center;">
            Attach
          </div>

          <div *matCellDef="let sent" style="width: 60px; text-align: center;">           
            <p *ngIf="sent.coreID>0"><mat-icon matTooltip="{{CoreShowName}} - {{sent.attachName}}">app_registration</mat-icon></p> 
            <p *ngIf="sent.contactID>0"><mat-icon matTooltip="{{ContactShowName}} - {{sent.attachName}}">contact_mail</mat-icon></p>
            <p *ngIf="sent.companyID>0"><mat-icon matTooltip="{{CompanyShowName}} - {{sent.attachName}}">business</mat-icon></p>        
          </div> 
        </ng-container> 

        <ng-container matColumnDef="action">
          <div class="action" *matHeaderCellDef>Action</div>

        <div class="action" *matCellDef="let sent" (click)="$event.stopPropagation()">            
          
          <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
            <mat-icon>more_vertical</mat-icon> 
          </button>
          <mat-menu #formTypeOpt="matMenu" xPosition="before">     
            
            <a href="{{sent.signingToken}}" target="_blank" mat-menu-item  matTooltipClass="tooltip" matTooltip="View Project">
              <mat-icon>preview</mat-icon> View Project
            </a>

            <button mat-menu-item (click)="resetProject(sent)" matTooltipClass="tooltip" matTooltip="Edit & Reset Project">
              <mat-icon>create</mat-icon> Edit & Reset
            </button>

            <button mat-menu-item [disabled]="sent.status!=3" (click)="downloadDocument(sent)" matTooltipClass="tooltip" matTooltip="Download">
              <mat-icon>cloud_download</mat-icon> Download
            </button>

            <button mat-menu-item  (click)="movetoTrash(sent.projectInboxSentId)" matTooltipClass="tooltip" matTooltip="Move to trash">
             <mat-icon>delete_outline</mat-icon> Delete
            </button>

          </mat-menu>

        </div>
        </ng-container>
        <mat-header-row  class="list ehead" *matHeaderRowDef="displayedColumnsAdvSearch"></mat-header-row>

        <mat-row (click)="showParticipantDetail(row)" class="list erow"
        [ngClass]="{'selected_row': row.projectInboxSentId === projectInboxSentId }"  *matRowDef="let row; columns: displayedColumnsAdvSearch"></mat-row>
      </mat-table>

      <div *ngIf="noRecordFound" class="noRecordFound">No Record Found</div>

      <mat-paginator *ngIf="!noRecordFound" [length]="paginatorTotalLength"
      [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]"
      itemsPerPageLabel="Records Per Page" showFirstLastButtons
      (page)="pageEventPropogate($event)">
      </mat-paginator>
    </mat-card> 


  </div>


  <!-- Core page Structure -->
  <!-- Document Detail  -->
  
  <!-- <mat-card class="documentDetail" [ngClass]="{ open: docDetail }">
    <app-doc-detail></app-doc-detail>
  </mat-card> -->

  <mat-card class="documentDetail" [ngClass]="{ open: groupDetail }">
    <app-group-detail     
      [participantList]="ParticipantList" [selectedSentItem]="selectedSentItem"></app-group-detail>
  </mat-card>
  <div class="documentDetailoverlay" (click)="closeDetail()" [ngClass]="{ open: groupDetail }"></div>
  
  <!-- Document Detail -->
</div>

<ng-template #SentProjectDetail>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>work</mat-icon></span>
    Project Status
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div class="panel">
      <div class="groupHolder" *ngFor="let p of ParticipantList">
        <div class="groupheading">        
          <h2><mat-icon>create</mat-icon>{{p.groupName}}</h2>
          <div class="status"><button mat-icon-button matTooltipClass="tooltip" matTooltip="Reset to all participant of this group" ><mat-icon>settings_backup_restore</mat-icon></button></div>
        </div>

        <div class="moveblock example-box">
          <div class="userInfo">
            <div class="chipss">
              <mat-chip-list>              
                <mat-chip> {{p.relationName}} </mat-chip>
              </mat-chip-list>
            </div>

            <div class="selectContact">
              <div class="userpic" *ngIf="p.participantImageURL">
                <img [src]="p.participantImageURL" alt="" />
              </div>

              <div class="userpic" *ngIf="!p.participantImageURL">
                <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
              </div>
             
              <div class="info">               
                <p>{{p.participantName}}</p>
              </div>
              
            </div>
            <div class="email">
              <input type="text" value="{{p.participantEmail}}" placeholder="Email required">
            </div>
            
          </div>
          <div class="Cancel">
            <div class="status">
              <p>Viewed</p>
            </div>
            <button mat-icon-button matTooltipClass="tooltip" matTooltip="Reset"><mat-icon>settings_backup_restore</mat-icon></button>
            <button mat-icon-button matTooltipClass="tooltip" matTooltip="Send Reminder"><mat-icon>notifications_active</mat-icon></button>
            <button mat-icon-button matTooltipClass="tooltip" matTooltip="Sign"><mat-icon>create</mat-icon></button>  
          </div>
        </div>
      </div>

   
    </div>

   
  </mat-dialog-content>

  <mat-dialog-actions >
    <button mat-button color="" (click)="close()">Close</button>
    <button mat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #advFilter>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Project Advanced Search
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>   
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="allheaders">    
      
    <mat-form-field class="example-half-width">                
        <mat-label>Participant Name/Email</mat-label>
        <input matInput placeholder="Participant Name/Email" [(ngModel)]="emailAdvSearch">
    </mat-form-field>

      <section class="example-section">
        <mat-checkbox color="primary" (change)="getCheckboxValues($event, 1)">Sent</mat-checkbox> &nbsp;&nbsp;
        <mat-checkbox color="primary" (change)="getCheckboxValues($event, 2)">In Progress</mat-checkbox>&nbsp;&nbsp;
        <mat-checkbox color="primary" (change)="getCheckboxValues($event, 3)">Completed</mat-checkbox>
      </section>
     

   <div class="d-flex">
    <div class="w5">
      <mat-form-field class="example-full-width" appearance="">
        <mat-label>Choose from date</mat-label>
        <input matInput [matDatepicker]="picker1" [(ngModel)]="fromDate" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>     
    </div>
          
      
    <div class="w5">
      <mat-form-field class="example-full-width" appearance="">
        <mat-label>Choose to date</mat-label>
        <input matInput [matDatepicker]="picker2" 
          [(ngModel)]="toDate" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>    
    </div>
   </div>

   

  <mat-form-field appearance="">
    <mat-label>Form Name</mat-label>
    <mat-select (selectionChange)="formNameSelection($event)">
      <mat-option *ngFor="let fileType of formList" [value]="fileType.formID">
        {{ fileType.formName }}
      </mat-option>
    </mat-select>
  </mat-form-field> 

  <mat-form-field class="example-half-width">                
    <mat-label>Project Name/Subject</mat-label>
    <input matInput placeholder="Project Name/Subject" [(ngModel)]="ProjectName">
   </mat-form-field>

   <!-- <mat-form-field class="example-half-width">                
    <mat-label>Subject</mat-label>
    <input matInput placeholder="Subject" [(ngModel)]="subject">
   </mat-form-field> -->

   <!-- <mat-form-field appearance="">
    <mat-label>Document Name</mat-label>
    <mat-select (selectionChange)="documentSelection($event)">
      <mat-option *ngFor="let fileType of projectDocuments" [value]="fileType.projectDocumentID">
        {{ fileType.documentName }}
      </mat-option>
    </mat-select>
  </mat-form-field>  -->

   <!-- <mat-form-field appearance="" *ngIf="isOrganizationAdmin==true">
    <mat-label>Sent By</mat-label>
    <mat-select (selectionChange)="sentBySelection($event)">
      <mat-option *ngFor="let fileType of userData" [value]="fileType.uuid">
        <div class="dropdowns">
          <p>{{ fileType.firstName }} {{ fileType.lastName }}</p>
          <span>{{ fileType.email }}</span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>  -->
 
  <mat-form-field *ngIf="isOrganizationAdmin==true">
    <mat-label>Sent By</mat-label>
    <mat-select (selectionChange)="sentBySelection($event)">
      <mat-option *ngFor="let fileType of userData" [value]="fileType">
        <div class="dropdowns">
          <p>{{ fileType.firstName }} {{ fileType.lastName }}</p>
          <span>{{ fileType.email }}</span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>

    </div>

  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button class="calltoaction" type="submit"             
    (click)="searchAdvFilter()" color="primary">
       Search
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>

</ng-template>
